import { render, staticRenderFns } from "./EntregaAprovarReprovar.vue?vue&type=template&id=51850604"
import script from "./EntregaAprovarReprovar.vue?vue&type=script&lang=js"
export * from "./EntregaAprovarReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports